import { Box, Grid } from "@mui/material";
import Header from "components/Header/Header";
import SearchResults from "components/lists/SearchResults/SearchResults";
import PageArrows from "components/PageArrows/PageArrows";
import SearchForm from "components/SearchForm/SearchForm";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";
import MainContainer from "components/styled/MainContainer";
import React, { useContext, useRef } from "react";
import { PAGES } from "utils/constants";
import { PageContext } from "utils/PageContext";
import { UserContext } from "utils/UserContext";

function Searchpage() {
  const {
    searched,
    setSearched,
    setSearchQuery,
    setAlbums,
    albumsLoading,
    setAlbumsLoading,
    setAlbumTracks,
    selectedAlbum,
  } = useContext(UserContext);

  const { setPage } = useContext(PageContext);

  const searchFormRef = useRef(null);

  const isPageComplete = selectedAlbum?.id?.length > 0;

  const handlePrevPage = () => {
    searchFormRef.current.reset();
    setSearched(false);
    setSearchQuery("");
    setAlbums([]);
    setAlbumTracks([]);
    window.sessionStorage.removeItem("SearchQuery");
    window.sessionStorage.removeItem("AlbumData");
    setPage(PAGES.HOME);
  };

  const handleNextPage = () => {
    setPage(PAGES.SCORETYPE);
  };

  return (
    <>
      <Header />
      <Box
        component="section"
        sx={{
          paddingTop: "calc(2rem + 100px)",
          paddingBottom: "1rem",
        }}
      >
        <CenteredColumnGrid container>
          <Grid item>
            <SearchForm
              setAlbumsLoading={setAlbumsLoading}
              setAlbums={setAlbums}
              setAlbumTracks={setAlbumTracks}
              searchFormRef={searchFormRef}
            />
          </Grid>
        </CenteredColumnGrid>
      </Box>

      <MainContainer
        component="main"
        sx={{
          overflowY: searched && !albumsLoading ? "scroll" : "hidden",
        }}
      >
        <CenteredColumnGrid container>
          <Grid item sm={8}>
            <SearchResults />
          </Grid>
        </CenteredColumnGrid>
      </MainContainer>

      <PageArrows
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
        isPageComplete={isPageComplete}
      />
    </>
  );
}

export default Searchpage;
